<!--包装原型-->
<template>
  <el-main class="bg_white wrap_box lc_rw">
    <!-- 按钮组 -->
    <LcButtons ref="lcButtons" :type="2" @btsEmit="btsEmit($event)" :planStratTime="data.baseInfo.plan_start_time_text"
      :ids="ids" :projectName="data.baseInfo.project_name" :reviewerUserId="data.baseInfo.reviewer_user_id"
      :userId="data.baseInfo.leader_user_id" :msg="data.baseInfo.msg" @getPageInfo="getPageInfo"
      :deppgetPageInfo="getPageInfo" />
    <!-- 基础信息 -->
    <div class="lc_ttop">
      <lcBaseInfo ref="addBaseInfo" type="taskInfo"></lcBaseInfo>
    </div>
    <!-- 包装原型 -->
    <div class="lc_title lc_ttop lc_add_ggdyb">包装原型</div>
    <lcbzyxtable v-model:bzyxTableData='data.bzyxTableData' v-model:selectlist='data.selectbzyxlist'></lcbzyxtable>
    <!--输出内容-->
    <div class="lc_title lc_ttop lc_add_ggdyb">输出内容</div>
    <lcwjsc v-model:loading="bzyxpptdata.loading" v-model:tableHeigth="bzyxpptdata.tableHeigth"
      v-model:listHeader="bzyxpptdata.listHeader" v-model:defaultRow="bzyxpptdata.defaultRow"
      v-model:tableHeader="bzyxpptdata.tableHeader" v-model:notShowCol="bzyxpptdata.notShowCol"
      v-model:staticList="bzyxpptdata.staticList" v-model:beforeStrList="bzyxpptdata.beforeStrList"
      @getClickBtnType="getClickBtnType_bzyxppt" @uploadAddRow="uploadAddRow" />
    <!--备注-->
    <div class="lc_ttop lc_bzt">备注</div>
    <div style="padding-bottom: 50px;">
      <lctinymce :id="data.id" ref="editor" :height="data.height" :cur-value="data.remark" @input="inputContent"
        :key="data.key"></lctinymce>
    </div>
    <!-- 填写共享盘链接 -->
    <LcWriteLinks :key="bzyxpptdata.isShowLinksDialogIndex" v-model:isShowLinksDialog="bzyxpptdata.isShowLinksDialog"
      @getDragWriteData="getDragWriteData" />
  </el-main>
</template>
<script>
import { defineComponent, reactive, ref, onMounted, getCurrentInstance, provide } from 'vue';
import { getBaseInfoFile, getComCurrentDate } from '../../../utils/lc_jx_utils/lc_jx.js'
import { cpPPT_defaultVal, cpppt_headerBtns, cpPPT_listHeader } from '../../../utils/lc_data'
import { downloadMod, addOrderNumber } from '../../../utils/lc'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
export default defineComponent({
  name: 'bzyx',
  setup (props) {
    let route = useRouter()
    provide('project_id', route.currentRoute.value.query.id)
    const addBaseInfo = ref()
    const lcButtons = ref()
    let { proxy } = getCurrentInstance()
    const ids = ref(route.currentRoute.value.query.prBasetaskId)
    let data = reactive({
      baseInfo: {},//基础信息
      bzyxTableData: [],//包装原型
      selectbzyxlist: [],// 勾选的包装原型
      //富文本
      height: 300,
      key: '',
      id: '',
      remark: '',// 备注
    })
    // 基本信息字段值
    let baseInfokeys = reactive({
      keyArry: ['sn', 'project_sn', 'name', 'required_time_text', 'status', 'leader_user_id', 'reviewer_user_id', 'task_status_text', 'examine_status_text', 'project_id', 'project_name', 'plan_start_time', 'plan_start_time_text', 'plan_end_time', 'plan_end_time_text', 'end_time_text']
    })
    // 输出内容
    let bzyxpptdata = reactive({
      tableTitle: '',
      tableHeigth: 180,
      loading: false,
      isShowLinksDialog: false,
      listHeader: JSON.parse(JSON.stringify(cpPPT_listHeader)),
      defaultRow: JSON.parse(JSON.stringify(cpPPT_defaultVal)),
      tableHeader: JSON.parse(JSON.stringify(cpppt_headerBtns)),
      notShowCol: [],
      beforeStrList: [],
      staticList: {},
    })
    onMounted(() => {
      getPageInfo()
    })
    //按钮组操作
    function getPageInfo (value) {
      proxy.$http.get('project/task/packing/info', { id: route.currentRoute.value.query.prBasetaskId }).then(res => {
        if (res.errno == 200) {
          data.baseInfo = JSON.parse(JSON.stringify(res.data))
          ids.value = res.data.id
          //包装原型表格
          data.bzyxTableData = addOrderNumber(res.data.packing)
          if (data.bzyxTableData && data.bzyxTableData.length > 0) {
            data.selectbzyxlist = []
            data.bzyxTableData.forEach(it => {
              if (it.selected == '1') {
                data.selectbzyxlist.push(it.id)
              }
            })
          }
          // 输出原型
          bzyxpptdata.defaultRow = res.data.files.packaging_prototype ? getBaseInfoFile(res.data.files.packaging_prototype) : []
          //备注
          data.remark = res.data.remark
          // 驳回原因
          addBaseInfo.value.data.reject = res.data && res.data.reject ? res.data.reject : ''
          // 基础信息
          baseInfokeys.keyArry.forEach(it => {
            addBaseInfo.value.taskform[it] = res.data[it]
          })
        } else {
          ElMessage({
            type: 'success',
            message: res.errmsg
          })
        }
      })
    }
    //按钮组操作
    function btsEmit (value) {
      // 提交和审核先做保存的动作
      if (value == 'passBt' || value == 'submitBt') {
        handelSavePage(value)
      }
      // 保存
      if (value == 'saveBt') {
        handelSavePage()
      }
    }
    // 保存页面
    function handelSavePage (bttype) {
      proxy.$http.showLoading(false).post('project/task/packing/edit', {
        id: data.baseInfo.id,
        leader_user_id: addBaseInfo.value.taskform['leader_user_id'],
        reviewer_user_id: addBaseInfo.value.taskform['reviewer_user_id'],
        plan_start_time: addBaseInfo.value.taskform['plan_start_time_text'],
        plan_end_time: addBaseInfo.value.taskform['plan_end_time_text'],
        remark: data.remark,
        packing: data.bzyxTableData,
        files: { 'packaging_prototype': bzyxpptdata.defaultRow && bzyxpptdata.defaultRow.length > 0 ? bzyxpptdata.defaultRow : [] },
      }).then(res => {
        if (res.errno == 200) {
          ElMessage({
            type: 'success',
            message: res.errmsg
          })
          if (bttype == 'submitBt') {
            lcButtons.value.thesubmit(bttype)
          }
          if (bttype == 'passBt') {
            lcButtons.value.thepass(bttype)
          }
          getPageInfo()
        } else {
          ElMessage({
            type: 'error',
            message: res.errmsg
          })
        }

      })
    }
    // 表格按钮 -- 规格、板框定义点击
    function getClickBtnType_bzyxppt (type, selRow, code, allData) {
      //下载模板
      if (type == 'download') {
        downloadMod(data.baseInfo.basetask_id, '包装原型')
      }
      if (type == 'write_links') {
        bzyxpptdata.isShowLinksDialogIndex = data.isShowLinksDialogIndex + 1
        bzyxpptdata.isShowLinksDialog = true
        bzyxpptdata.btnTamplteList = JSON.parse(JSON.stringify(allData))
      }
    }
    // 文件上传
    function uploadAddRow (s_list) {
      bzyxpptdata.loading = true
      let list = JSON.parse(JSON.stringify(s_list.table_list))
      list.push({ id: 0, title: s_list.name, create_time: s_list.date, remark: '', url_type: 'file', isDownLoadShow: 'yes', url: s_list.url, downLoadUrl: s_list.url })
      bzyxpptdata.defaultRow = list
      setTimeout(() => {
        proxy.$message.success('文件上传成功')
        bzyxpptdata.loading = false
      }, 800);
    }
    // 填写共享盘链接
    function getDragWriteData (val) {
      bzyxpptdata.loading = true
      bzyxpptdata.btnTamplteList.push({ id: 0, title: val, create_time: getComCurrentDate(), remark: '', url_type: 'link', url: '' })
      bzyxpptdata.defaultRow = bzyxpptdata.btnTamplteList
      setTimeout(() => {
        proxy.$message.success('链接添加成功')
        bzyxpptdata.loading = false
      }, 800);
    }
    //富文本编辑器
    function inputContent (value) {
      data.remark = value
    }
    return {
      data,
      ids,
      bzyxpptdata,
      addBaseInfo, lcButtons,
      btsEmit,
      getPageInfo,
      getClickBtnType_bzyxppt,
      uploadAddRow,
      getDragWriteData,
      inputContent
    }
  }
})
</script>
<style scoped lang="scss">
@import '../../../assets/style/lc.scss';
</style>